module.exports = __webpack_public_path__ + "img/discount.9d51bb4b.svg";